import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { SynchronizeAccountsRequestModel, SynchronizeAccountsResponseModel } from "@/features/accounts/finance/services/synchronize-accounts-model";

export class SynchronizeAccountsApi {
  /**
   * 銀行口座アカウント同期API
   */
  public synchronizeAccounts = async (
    param: SynchronizeAccountsRequestModel
  ): Promise<SynchronizeAccountsResponseModel> => {
    const path = `/api/financeaccounts/synchronize`;
    const res = await ApiClient.instance.post<SynchronizeAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
